'use strict'
const parser = require('./parser')

module.exports = {
    parser
}
